<template>
  <div>
    <el-card style="margin-top: 15px;">
        <el-row class="title_row">
          <el-col :span="6">
            <span class="title_class">裁判系统</span>
          </el-col>
          <el-col :span="18">
            <el-form
              :model="queryForm"
              class="filter_Form"
              label-width="60px"
              ref="queryFormRef"
            >
              <el-row>
                <el-col :span="10" :offset="14">
                  <el-form-item label="赛季" prop="season">
                    <el-select
                      placeholder="请选择"
                      v-model="queryForm.season"
                      @change="getMatchInfo"
                    >
                      <el-option
                        v-for="item in dict_season"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictValue"
                      ></el-option>
                    </el-select>
                    <el-button type="primary" style="margin-left: 12px;" @click="getMatchInfo">查询</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <div>
          <el-button type="primary" plain icon="el-icon-document-checked" @click="showSignInInfoDialog()">选手信息</el-button>
          <el-button type="primary" plain icon="el-icon-download" @click="exportFn()">下载裁判席用表</el-button>
          <el-button type="primary" plain icon="el-icon-s-data" @click="showRankInfoDialog()">实时排名</el-button>
          <el-button type="primary" plain icon="el-icon-link" @click="copy">大屏排行榜</el-button>
          <el-button type="primary" plain icon="el-icon-download" @click="downloadInfoList()">导出本轮晋级/淘汰名单</el-button>
          <el-button  type="primary" plain icon="el-icon-refresh" @click="resetAllRoundsDialogVisable = true">重置所有轮次</el-button>
          <el-button type="success" icon="el-icon-switch-button" @click="beginnGame()">开始比赛</el-button>
        </div>
      </el-card>
      <el-card style="margin-top: 15px;">
        <div class="default" v-if="!matchInfo.length">
          <el-empty description="暂无数据"></el-empty>
        </div>
        <el-tabs
            class="cpxt"
            v-if="matchInfoShow"
            v-model="currentMatchInfoIndex"
            @tab-click="getMatchInfo('select')"
        >
            <el-tab-pane
                v-for="(item, i) in matchInfo"
                :label="'round' + item.round + '-' + item.roundName"
                :name="i + ''"
                :key="i"
            >
                <template slot="label">
                    <div
                        class="usual-tab-card"
                        :class="'usual-tab-card' + item.roundType"
                    >
                        {{ "round" + item.round + "-" + item.roundName }}
                    </div>
                </template>
                <el-row :gutter="10" class="tab-headview">
                    <el-col
                        :span="18"
                        style="font-size: 20px"
                        v-if="item.roundType !== -110"
                    >
                        <span style="margin-left: 30px; color: #67c23a"
                            >预晋级人数:{{ statisticsInfo.setPassNum }}</span
                        >
                        <span style="margin-left: 30px; color: #67c23a"
                            >已晋级人数:{{ statisticsInfo.passedNum }}</span
                        >
                        <span style="margin-left: 30px; color: #e6a23c"
                            >本轮人数:{{ statisticsInfo.curNum }}</span
                        >
                        <span style="margin-left: 30px; color: #e6a23c"
                            >本轮晋级:{{ statisticsInfo.curPass }}</span
                        >
                        <span style="margin-left: 30px; color: #e6a23c"
                            >本轮淘汰:{{ statisticsInfo.curOut }}</span
                        >
                        <span style="margin-left: 30px; color: #e6a23c"
                            >本轮待比赛:{{ statisticsInfo.curWait }}</span
                        >
                    </el-col>
                    <el-col
                        :span="18"
                        style="font-size: 20px"
                        v-if="item.roundType === -110"
                    >
                        <span style="margin-left: 20px; color: #fdba01"
                            >参赛人数:{{ statisticsInfo.userNum }}</span
                        >
                        <span style="margin-left: 20px; color: #67c23a"
                            >晋级人数:{{ statisticsInfo.promotedNum }}</span
                        >
                        <span style="margin-left: 20px; color: #ff0000"
                            >淘汰人数:{{ statisticsInfo.notPromotedNum }}</span
                        >
                    </el-col>
                    <el-col
                        :span="3"
                        style="text-align: right"
                        v-if="item.roundType !== -110"
                    >
                        <el-button
                            type="primary"
                            size="medium"
                            @click="showSetPromotionDialog(item)"
                            style="width: 100%"
                            v-if="showSetPromotionButton"
                            >设置晋级</el-button
                        >
                    </el-col>
                    <el-col :span="3" style="text-align: right">
                        <el-button
                            type="danger"
                            size="medium"
                            @click="resetMatch(item)"
                            style="width: 100%"
                            v-if="showBackButton"
                            >比赛回退</el-button
                        >
                    </el-col>
                </el-row>
                <el-table
                    header-cell-class-name="tableHeaderStyle"
                    :data="showPlayers"
                    border
                    :row-class-name="tableRowClassName"
                >
                    <el-table-column type="index" label="#"></el-table-column>
                    <el-table-column
                        label="学校"
                        prop="schoolName"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="年级"
                        prop="grade"
                        width="120"
                        :formatter="gradeFormatter"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        label="选手姓名"
                        width="180"
                        prop="userName"
                        align="center"
                    >
                        <template scope="scope">
                            <span class="nationalnum"
                                >{{ scope.row.userName }}
                                {{
                                    scope.row.countryReserve === true
                                        ? "(保留)"
                                        : ""
                                }}</span
                            >
                        </template></el-table-column
                    >
                    <el-table-column
                        label="比赛号码牌"
                        width="120"
                        prop="nationalnum"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div class="num num1">
                                {{ addZero(scope.row.nationalnum)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="抽签顺序号"
                        width="120"
                        prop="competitionNumber"
                        align="center"
                    >
                    <template slot-scope="scope">
                      <span class="num">{{ addZero(scope.row.competitionNumber) }}</span>
                    </template>
                    </el-table-column>
                    <el-table-column
                        label="晋级"
                        v-if="item.roundType !== -110"
                        width="160px"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-checkbox
                                border
                                label="晋级"
                                size="small"
                                :class="
                                    scope.row.promoted === '1'
                                        ? 'promoted-btn'
                                        : ''
                                "
                                v-model="scope.row.promoted"
                                true-label="1"
                                false-label=""
                                :key="scope.row.playerId"
                                @change="upDateStatisticsInfo(item, scope.row)"
                            >
                            </el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="淘汰"
                        v-if="item.roundType !== -110"
                        width="160px"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-checkbox
                                border
                                label="淘汰"
                                size="small"
                                :class="
                                    scope.row.promoted === '0'
                                        ? 'eliminate-btn'
                                        : ''
                                "
                                v-model="scope.row.promoted"
                                true-label="0"
                                false-label=""
                                :key="scope.row.playerId"
                                :style="{ '--fill-color': '#F56C6C' }"
                                @change="upDateStatisticsInfo(item, scope.row)"
                            >
                            </el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="排名"
                        prop="promoted"
                        align="center"
                        width="100px"
                        v-if="item.roundType === -110"
                    >
                        <template slot-scope="scope">
                            <div
                                :class="
                                    scope.row.promoted === 1
                                        ? 'rank-success'
                                        : ''
                                "
                            >
                                {{ scope.row.ranking }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="名次"
                        v-if="item.roundType === -110"
                        prop="score_promoted"
                        width="100px"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <!-- <div
                                :class="
                                    scope.row.promoted === 1
                                        ? 'rank-success'
                                        : ''
                                "
                            >
                                {{ scope.row.rankingName }}
                            </div> -->
                            <div
                              style="font-size: 16px; font-weight: 800;"
                                :class="
                                    scope.row.rankingName === '冠军' ? 'guanjun' : (scope.row.rankingName === '亚军' ? 'yajun' : (scope.row.rankingName === '季军' ? 'jijun' : ''))
                                "
                            >
                                {{ scope.row.rankingName }}
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <!-- 查看签到情况的Dialog -->
        <el-dialog
            :title="'选手信息（本轮 ' + signInInfo.length + ' 人）'"
            :visible.sync="signInInfoDialogVisable"
            width="60%"
        >
            <el-table
                style="margin-top: 0"
                header-cell-class-name="tableHeaderStyle"
                :data="signInInfo"
                border
            >
                <el-table-column type="index"></el-table-column>
                <el-table-column label="姓名" prop="name">
                    <template scope="scope">
                        <span
                            >{{ scope.row.userName }}
                            {{
                                scope.row.countryReserve === true
                                    ? "(保留)"
                                    : ""
                            }}</span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="比赛号码牌"
                    prop="matchNum"
                    width="180px"
                >
                  <template slot-scope="scope">
                    <span class="num num1">{{ addZero(scope.row.matchNum) }}</span>
                  </template></el-table-column
                >
                <el-table-column
                    label="抽签顺序号"
                    prop="matchNum"
                    width="180px"
                >
                  <template slot-scope="scope">
                    <span class="num">{{ addZero(scope.row.raceNumber) }}</span>
                  </template></el-table-column
                >
                <el-table-column
                    label="学校"
                    prop="schoolName"
                ></el-table-column>
                <el-table-column label="年级" prop="grade" :formatter="gradeFormatter"></el-table-column>
            </el-table>
        </el-dialog>
        <!-- 设置晋级人数的Dialog -->
        <el-dialog
            title="设置晋级人数"
            :visible.sync="setPromotionNumberDialogVisable"
            width="500px"
        >
            <el-form label-width="80px">
                <el-form-item label="晋级人数">
                    <el-input
                        type="number"
                        v-model="promotionNum"
                        :disabled="!setPromotionNumberEnable"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span
                slot="footer"
                class="dialog-footer"
                v-if="setPromotionNumberEnable"
            >
                <el-button type="primary" @click="setPromotionNumber()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 设置晋级的Dialog -->
        <el-dialog
            title="设置晋级"
            :visible.sync="setPromotionDialogVisible"
            width="50%"
        >
            <div style="font-size: 18px">
                本轮为：{{ currentTurnName }} ，参赛人数：{{
                    currentTurnUserNum
                }}
            </div>
            <div style="color: #f56c6c; font-size: 18px; margin-top: 40px">
                本轮淘汰选手：{{ setPromotionTipsOut.length }} 人,
                {{ rankTitleStr }}
            </div>
            <el-row>
                <el-col
                    v-for="(item, index) in setPromotionTipsOut"
                    :key="index"
                    :span="6"
                >
                    <span style="color: #f56c6c"
                        ><span style="font-weight: bold">{{
                            item.competitionNumber
                        }}</span
                        >号-{{ item.userName }}</span
                    >
                </el-col>
            </el-row>
            <div style="color: #67c23a; margin-top: 40px; font-size: 18px">
                本轮晋级选手：{{ setPromotionTipsPass.length }} 人,
                {{ rankTitleStrJ }}
            </div>
            <el-row>
                <el-col
                    v-for="(item, index) in setPromotionTipsPass"
                    :key="index"
                    :span="6"
                >
                    <span style="color: #67c23a"
                        ><span style="font-weight: bold">{{
                            item.competitionNumber
                        }}</span
                        >号-{{ item.userName }}</span
                    >
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="danger"
                    v-if="setPromotionTipsPass.length > 1"
                    @click="promotTied()"
                    >并列晋级</el-button
                >
                <el-button @click="setPromotionDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="setPromotion()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 查看实时排名的Dialog -->
        <el-dialog
            :visible.sync="showRealTimeRankingDialogVisable"
            width="70%"
        >
        <span slot="title">
          实时排名
        </span>
            <el-table
                style="margin-top: 0"
                header-cell-class-name="tableHeaderStyle"
                :data="rankInfo"
                border
            >
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column
                    label="姓名"
                    width="120"
                    prop="userName"
                ></el-table-column>
                <el-table-column
                    label="比赛号码牌"
                    width="120"
                    prop="nationalnum"
                >
                    <template slot-scope="scope">
                        <span class="num num1">{{ addZero(scope.row.nationalnum) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="抽签顺序号"
                    width="120"
                    prop="competitionNumber"
                    align="center"
                >
                  <template slot-scope="scope">
                    <span class="num">{{ addZero(scope.row.competitionNumber) }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    label="学校"
                    prop="schoolName"
                ></el-table-column>
                <el-table-column label="年级" width="120" prop="grade" :formatter="gradeFormatter"></el-table-column>
                <el-table-column
                    label="排名"
                    width="120"
                    prop="promoted"
                    align="center"
                >
                    <template slot-scope="scope">
                        <div style="color: green; font-size: 20px">
                            {{ scope.row.ranking }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="名次"
                    prop="score_promoted"
                    width="100"
                    align="center"
                >
                    <template slot-scope="scope">
                        <div
                            style="font-size: 16px; font-weight: 800"
                            :class="
                                scope.row.rankingName === '冠军'
                                    ? 'guanjun'
                                    : scope.row.rankingName === '亚军'
                                    ? 'yajun'
                                    : scope.row.rankingName === '季军'
                                    ? 'jijun'
                                    : ''
                            "
                        >
                            {{ scope.row.rankingName }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!-- 重置所有轮次 -->
        <el-dialog
            title="重置所有轮次"
            :visible.sync="resetAllRoundsDialogVisable"
            width="40%"
        >
            <el-form label-width="80px">
                <el-form-item label="输入密码">
                    <el-input type="text" v-model="password"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="resetAllRounds()"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  setCityFinalRoundFinal, getPromotionNumFinal, citySetPromotionNumFinal, nationalNoGroupSetPromotion, selectUserByRoundFinal, resetMatchFinal,
  resettingFinal, getMatchWinnersFinal, setPromotionPointFinal, setAbreastPromotionFinal, getPromotionRankingFinal, nationalStart
} from '@/http/api'

export default {
  name: 'groupC',
  props: {
    flag: {
      Type: String,
      default: 0
    }
  },
  data () {
    return {
      dict_group: this.$userInfo.dict_group(), // 组别下拉列表
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }), // 赛季下拉列表
      dict_grade: this.$userInfo.getGradeData(), // 年级
      rankTitleStrJ: '',
      rankTitleStr: '',
      password: '',
      showPlayers: [],
      showRealTimeRankingDialogVisable: false,
      matchInfoShow: false,
      e_sex: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.e_sex = value }),
      queryFormRule: {
        level: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        raceSchedule: 4,
        season: this.$chnEngStatusCode.defaultSeason,
        round: 8,
        isGroup: 2
        // level: ''
      },
      resetAllRoundsDialogVisable: false,
      matchInfo: [],
      signInInfoDialogVisable: false,
      setPromotionNumberDialogVisable: false,
      promotionNum: 0,
      setPromotionNumberEnable: false,
      signInInfo: [],
      rankInfo: [],
      currentMatchInfoIndex: '',
      statisticsInfo: {
        setPassNum: '',
        passedNum: '',
        curNum: '',
        curPass: '',
        curOut: '',
        curWait: ''
      },
      setPromotionDialogVisible: false,
      setPromotionTipsOut: [],
      setPromotionTipsPass: [],
      setPromotionData: []
    }
  },

  methods: {
    init () {
      this.dataList = []
      this.getMatchInfo()
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.roundType !== -110) {
        if (row.promoted === '0') {
          return 'warning-row'
        } else if (row.promoted === '1') {
          return 'success-row'
        } else {
          return ''
        }
      }
      return ''
    },
    goBack () {
      this.$router.back()
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    nationalnumFormatter (num) {
      return this.$xcUtils.addZero(num)
    },
    // 开始比赛
    beginnGame () {
      nationalStart(this.queryForm).then((res) => {
        this.getMatchInfo()
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 获取轮次信息
    getMatchInfo (flag) {
      if (flag === 'select') {
        this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
      } else {
        setCityFinalRoundFinal(this.queryForm).then((res) => {
          this.matchInfo = res.data
          if (this.matchInfo.length !== 0) {
            this.currentMatchInfoIndex = this.matchInfo.length - 1 + ''
            this.getRoundPlayerInfo(this.matchInfo[this.currentMatchInfoIndex])
            this.matchInfoShow = true
          }
        }).catch((err) => {
          console.log('返回的err', err)
        })
      }
    },
    gradeFormatter (data) {
      return data.grade ? this.dict_grade.find(item => item.dictCode === data.grade).dictLabel : '--'
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    showSignInInfoDialog () {
      this.$http.get('/national/queryNationalGroupList', { params: this.queryForm }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.signInInfo = res.data
          this.signInInfoDialogVisable = true
        }
      })
    },
    exportFn () {
      this.$downLoadFile.downLoadFileWithUrlNew(this, (this.$env.baseIP + 'national/exportNationalGroupList'), this.queryForm)
    },
    // 查看实时排名
    showRankInfoDialog () {
      getMatchWinnersFinal(this.queryForm).then((res) => {
        this.rankInfo = res.data.winners
        this.rankInfo.forEach((item, index) => {
          item.promoted = item.promoted + ''
          item.competitionNumber = this.nationalnumFormatter(item.competitionNumber)
        })
        this.showRealTimeRankingDialogVisable = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },

    showSetPromotionNumberDialog () {
      getPromotionNumFinal(this.queryForm).then((res) => {
        this.promotionNum = res.data.promotionNum
        if (this.promotionNum < 1) {
          this.promotionNum = 0
          this.setPromotionNumberEnable = true
        } else {
          this.setPromotionNumberEnable = false
        }
        this.setPromotionNumberDialogVisable = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    setPromotionNumber () {
      if (this.promotionNum === 0) {
        return this.$message.warning('晋级人数不能为0')
      }
      this.queryForm.promotionNum = this.promotionNum
      citySetPromotionNumFinal(this.queryForm).then((res) => {
        this.$message.success('设置成功')
        this.getMatchInfo()
        this.setPromotionNumberDialogVisable = false
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    genderFormatter (data) {
      var temp = '未设置'
      for (const key in this.e_sex) {
        if (Object.hasOwnProperty.call(this.e_sex, key)) {
          const element = this.e_sex[key]
          console.log('element.dictValue', element.dictValue)
          if (element.dictValue + '' === data.sex + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    showSetPromotionDialog (data) {
      this.setPromotionDataRequest(data)
    },
    // 处理晋级数据
    setPromotionDataRequest (data) {
      console.log('this.showPlayers', this.showPlayers)
      // 检查是否所有选手都设置了晋级状态
      var temp = []
      this.showPlayers.forEach(element => {
        if (element.promoted === '-1' || element.promoted === '') {
          temp.push(element)
        }
      })
      if (temp.length > 0) {
        var tempStr = ''
        temp.forEach(element => {
          tempStr += element.competitionNumber + '号-' + element.userName + '<br>'
          // tempStr += `${element.competitionNumber}号-${element.userName}`
        })
        return this.$alert(tempStr, '存在选手未设置晋级', {
          confirmButtonText: '确定',
          dangerouslyUseHTMLString: true
        })
      }
      // 再次确认本轮晋级情况
      // 初始化数据
      this.setPromotionTipsOut = []
      this.setPromotionTipsPass = []
      this.showPlayers.forEach(element => {
        if (element.promoted === '1') {
          this.setPromotionTipsPass.push(element)
        }
        if (element.promoted === '0') {
          this.setPromotionTipsOut.push(element)
        }
      })
      this.setPromotionData = data
      this.getEliminationRankingInformation()
    },

    // 获取淘汰排名信息
    getEliminationRankingInformation () {
      var playerIds = [] // 晋级比赛选手id
      this.showPlayers.forEach(element => {
        if (element.promoted === '1') {
          playerIds.push(element.playerId)
        }
      })
      this.queryForm.playerIds = playerIds
      this.queryForm.finalMatchId = this.setPromotionData.id
      getPromotionRankingFinal(this.queryForm).then((res) => {
        if (res.data.notPromotionRanking) {
          this.rankTitleStr = '获得名次：第' + res.data.notPromotionRanking + '名'
        } else {
          this.rankTitleStr = ''
        }
        if (res.data.promotionRanking) {
          this.rankTitleStrJ = '获得名次：第' + res.data.promotionRanking + '名'
        } else {
          this.rankTitleStrJ = ''
        }
        this.setPromotionDialogVisible = true
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    setPromotion (flag) {
      var playerIds = [] // 晋级比赛选手id
      this.showPlayers.forEach(element => {
        if (element.promoted === '1') {
          playerIds.push(element.playerId)
        }
      })
      this.queryForm.playerIds = playerIds
      this.queryForm.finalMatchId = this.setPromotionData.id
      if (flag === 'promotTied') {
        setAbreastPromotionFinal(this.queryForm).then((res) => {
          this.$curUtils.closeLoading(this)
          this.$message.success('设置晋级成功')
          this.setPromotionDialogVisible = false
          this.getMatchInfo()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      } else {
        nationalNoGroupSetPromotion(this.queryForm).then((res) => {
          this.$curUtils.closeLoading(this)
          this.$message.success('设置晋级成功')
          this.setPromotionDialogVisible = false
          this.getMatchInfo()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      }
    },
    upDateStatisticsInfo (data, rowData) {
      console.log('data', rowData)
      this.statisticsInfo.setPassNum = data.finalMathPromotedNum
      this.statisticsInfo.passedNum = data.winnwePromotedNum
      this.statisticsInfo.curNum = 0
      this.statisticsInfo.curPass = 0
      this.statisticsInfo.curOut = 0
      this.statisticsInfo.curWait = 0
      this.showPlayers.forEach(element => {
        this.statisticsInfo.curNum++
        if (element.promoted === '1') {
          this.statisticsInfo.curPass++
        } else if (element.promoted === '0') {
          this.statisticsInfo.curOut++
        } else {
          this.statisticsInfo.curWait++
        }
      })
      if (rowData) {
        this.setPromotedData(rowData)
      }
    },
    async setPromotedData (rowData) {
      if (rowData.promoted !== '' && rowData.promoted !== '-1') {
        console.log('this.queryForm', this.queryForm)
        setPromotionPointFinal({
          ...this.queryForm,
          ...{
            playerId: rowData.playerId,
            promoted: rowData.promoted
          }
        }, true).then((res) => {
        }).catch((err) => {
          console.log('返回的err', err)
        })
      }
    },
    // 获取轮次下指定选手列表
    getRoundPlayerInfo (showSchedule) {
      console.log('showSchedule', showSchedule)
      if (showSchedule.roundType === -110) { // 晋级名单单独处理
        getMatchWinnersFinal(this.queryForm).then((res) => {
          this.showPlayers = res.data.winners.map(item => {
            item.promoted = item.promoted + ''
            return item
          })
          this.statisticsInfo.userNum = res.data.userNum
          this.statisticsInfo.promotedNum = res.data.promotedNum
          this.statisticsInfo.notPromotedNum = res.data.notPromotedNum
        }).catch((err) => {
          console.log('返回的err', err)
        })
      } else {
        selectUserByRoundFinal({ finalMatchId: showSchedule.id }).then((res) => {
          this.showPlayers = res.data.map(item => {
            item.promoted = item.promoted + ''
            return item
          })
          this.upDateStatisticsInfo(showSchedule)
        }).catch((err) => {
          console.log('返回的err', err)
        })
      }
    },
    matchOver () {
      this.$confirm('比赛结束将由“已晋级选手”和“本轮晋级选手”直接生成晋级名单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setPromotion('matchOver')
      })
    },
    resetMatch (item) {
      this.$confirm('比赛回退将重新返回上一轮比赛未设置晋级的状态, 是否确认?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.queryForm.finalMatchId = item.id
        resetMatchFinal(this.queryForm).then((res) => {
          this.$message.success('比赛回退成功')
          this.getMatchInfo()
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    promotTied () {
      this.$confirm('并列晋级将由“本轮晋级选手”并列排名晋级, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setPromotion('promotTied')
      })
    },
    // 下载签到表
    downloadInfoList () {
      var downLoadUrl = ''
      if (this.matchInfo[this.currentMatchInfoIndex].roundType === -110) {
        downLoadUrl = this.$env.baseIP + 'cityMatch/final/exportMatchWinners'
      } else {
        downLoadUrl = this.$env.baseIP + 'cityMatch/final/excelUserByRound'
      }
      this.queryForm.finalMatchId = this.matchInfo[this.currentMatchInfoIndex].id
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, this.queryForm)
    },
    // 重置所有轮次
    resetAllRounds () {
      if (this.password !== '1qazxsw2cz') {
        return this.$message.error('密码错误！')
      }
      this.queryForm.password = this.password
      resettingFinal(this.queryForm).then((res) => {
        this.resetAllRoundsDialogVisable = false
        this.getMatchInfo()
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    copy () {
      if (!this.queryForm.season) {
        return this.$message.warning('请选择赛季')
      }
      var input = document.createElement('input') // 创建input标签
      var loc = window.location.origin
      const query = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        group: this.queryForm.isGroup,
        round: this.queryForm.isGroup === 1 ? 'C' : 'B'
      }
      input.value = `${loc}/#/pad/rank?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    }
  },
  computed: {
    showSetPromotionButton () {
      // var schduleArray = []
      // for (let index = 0; index < this.matchInfo.length; index++) {
      //   const element = this.matchInfo[index]
      //   if (element.roundType !== -110) {
      //     schduleArray.push(element)
      //   }
      // }
      return (Number(this.currentMatchInfoIndex) === this.matchInfo.length - 1 && this.matchInfo[this.matchInfo.length - 1].roundType !== -110)
    },
    showBackButton () {
      // var schduleArray = []
      // for (let index = 0; index < this.matchInfo.length; index++) {
      //   const element = this.matchInfo[index]
      //   if (element.roundType !== -110) {
      //     schduleArray.push(element)
      //   }
      // }
      return (Number(this.currentMatchInfoIndex) === this.matchInfo.length - 1) && (Number(this.currentMatchInfoIndex) !== 0)
    },
    currentTurnName () {
      if (this.matchInfo[this.currentMatchInfoIndex] !== undefined) {
        return this.matchInfo[this.currentMatchInfoIndex].roundName
      }
      return ''
    },
    currentTurnUserNum () {
      if (this.showPlayers) {
        return this.showPlayers.length
      }
      return ''
    }
  }
}
</script>
<style lang="less" scoped>
.num {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}
.num1{
  color: #000;
}
.refresh{
  color: #409EFF;
  cursor: pointer;
  margin-left: 12px;
}
.mb-10{
  margin-bottom: 10px;
}
.nationalnum {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    letter-spacing: 1px;
}

/deep/ .el-tabs__item.is-active {
    border-right-color: transparent;
    border-left-color: transparent;
    height: 50px;
    line-height: 56px;
    // background: #409EFF;
    color: #fff;
    font-size: 18px;
    border-radius: 20px 20px 0 0;
    .usual-tab-card {
        background: #409eff;
        padding-left: 24px;
        padding-right: 24px;
    }
}
.num {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}
.num1{
  color: #000;
}
</style>
